<div class="row">
  <div class="col-12 col-md-4">
    <div class="form-group">
      <select class="form-control" name="anio" id="anio" (change)="changeFilterYear($event)">
        <option value="2018">2018</option>
        <option value="2019">2019</option>
        <option value="2020">2020</option>
      </select>
    </div>
  </div>
  <div class="col-12 col-md-4">
    <div class="form-group">
      <select class="form-control" name="mes" id="mes" (change)="changeFilterMonth($event)">
        <option value="Enero">Enero</option>
        <option value="Febrero">Febrero</option>
        <option value="Marzo">Marzo</option>
        <option value="Abril">Abril</option>
        <option value="Mayo">Mayo</option>
        <option value="Junio">Junio</option>
        <option value="Agosto">Agosto</option>
        <option value="Septiembre">Septiembre</option>
        <option value="Octubre">Octubre</option>
        <option value="Noviembre">Noviembre</option>
        <option value="Diciembre">Diciembre</option>
      </select>
    </div>
  </div>
  <div class="col-12 col-md-4">
    <button type="button" name="button" class="btn btn-primary">Limpiar</button>
  </div>
</div>
<div id="parkMap" #parkMap class="mapa" style="height: 380px;"></div>
